module.exports = __webpack_public_path__ + "img/advancedData.bdc8c859.svg";